import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const NextPaymentLine = () => {
  const { previewMutation } = usePaywallCheckoutContext();
  const preview = previewMutation.data;

  if (!preview || previewMutation.isLoading) {
    return <SkeletonLoader variant="row" lg />;
  }

  const nextPaymentLineString = [];

  const hasTax =
    (preview?.first_payment?.tax || 0) > 0 ||
    (preview?.future_payments?.tax || 0) > 0;

  if (hasTax) {
    nextPaymentLineString.push(t("tax_included"));
  }

  if (preview.future_payments) {
    const nextPaymentDate = formattedDateTime({
      format: "short_month_and_date_with_year",
      dateTime: new Date(preview.future_payments.start_on),
    });

    nextPaymentLineString.push(
      t("next_payment", { next_payment_date: nextPaymentDate }),
    );
  }

  return (
    <Typography.BodyXs color="text-default">
      {nextPaymentLineString.join(" ")}
    </Typography.BodyXs>
  );
};
